import { jsx as r } from "react/jsx-runtime";
import { Box as e } from "@mui/material";
import { Typography as a } from "./index59.mjs";
import { progressBarValueClasses as p } from "./constants4.mjs";
import { mergeClassNames as t } from "./mergeClassNames.mjs";
const B = ({
  valueLabel: o,
  className: s,
  ...m
}) => /* @__PURE__ */ r(
  e,
  {
    ...m,
    className: t([p.root, s]),
    children: /* @__PURE__ */ r(a.Body1, { children: o })
  }
);
export {
  B as ProgressBarValue
};
//# sourceMappingURL=index133.mjs.map
